<img class="product-icon" [src]="'/assets/animations/product-icons/' + product().name.toLowerCase() + '.svg'" alt="" />

<h1>
  @if (canStartTrial()) {
    Try Picflow {{ product().name }}
  } @else {
    @if (mode() === 'upgrade') {
      Upgrade to {{ product().name }}
    } @else if (mode() === 'upgrade-early') {
      Upgrade to {{ product().name }}
    } @else if (mode() === 'downgrade') {
      Downgrade to {{ product().name }}
    } @else {
      Go {{ billingFrequency() | capitalize }}ly
    }
  }
</h1>

@if (mode() !== 'change-frequency') {
  <app-simple-switcher
    name="billing-frequency"
    location="checkout-page"
    [value]="billingFrequency() === 'year'"
    [reportingTrueValue]="'yearly'"
    [reportingFalseValue]="'monthly'"
    (onSwitch)="billingFrequency.set($event ? 'year' : 'month')"
  >
    <div offLabel [class.active]="billingFrequency() === 'month'"><span>Monthly</span></div>
    <div onLabel [class.active]="billingFrequency() === 'year'">
      <span
        >Yearly
        <app-badge [color]="billingFrequency() === 'year' ? 'green' : 'grey-50'">{{
          product() | monthYearDiff
        }}</app-badge></span
      >
    </div>
  </app-simple-switcher>
}

@if (validPromotion()) {
  <app-checkout-coupon [promotion]="promotion()"></app-checkout-coupon>
}

@if (showPlanChange() && price()) {
  <app-checkout-plan-change-box [price]="price()"></app-checkout-plan-change-box>
}

@if (existingCardMode()) {
  <app-checkout-existing-card
    [card]="cardData()?.card"
    (update)="existingCardMode.set(false)"
  ></app-checkout-existing-card>
} @else {
  <app-card-form (onSubmit)="confirm()" [showErrorSpacing]="true" #cardForm></app-card-form>
}
<app-checkout-pricing-details
  [price]="price()"
  [promotion]="promotion()"
  [mode]="mode()"
  [endTrialEarly]="endTrialEarly()"
  #pricingDetails
></app-checkout-pricing-details>

<button
  appButton
  name="confirm"
  location="checkout"
  data-test-id="checkout-confirm"
  color="primary"
  shape="round"
  height="4"
  size="3"
  appTransitionPreventor
  spacing="full"
  (click)="confirm()"
>
  <span [class.hidden-text]="submitting()">
    @if (canStartTrial()) {
      Start {{ trialDays }}-Day Trial
    } @else {
      Confirm
    }
  </span>
  @if (submitting()) {
    <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
  }
</button>

@if (canStartTrial()) {
  <div class="points">
    <div class="point">
      <app-svg src="/assets/icons/16/check.svg" alt=""></app-svg>
      <span>Billed after trial</span>
    </div>
    <div class="point">
      <app-svg src="/assets/icons/16/check.svg" alt=""></app-svg>
      <span>Cancel anytime</span>
    </div>
  </div>
} @else {
  <p class="legal">
    <app-svg src="/assets/icons/16/lock.svg"></app-svg>
    <span>Secure 128-Bit SSL Connection</span>
  </p>
}
